//Specs: https://docs.mapbox.com/mapbox-gl-js/style-spec/layers/

export const clusterLayer = {
    id: 'clusters',
    type: 'circle',
    source: 'pois',
    filter: ['has', 'point_count'],
    paint: {
        'circle-color': [
            'step',
            ['get', 'point_count'],
            '#FFEACC',
            10,
            '#FFD272',
            20,
            '#FFB83A',
            50,
            '#FBA919',
            150,
            '#F68920'
        ],
        'circle-radius': ['step', ['get', 'point_count'], 15, 30, 18, 50, 20, 100, 25, 200, 30]
    }
};

export const clusterCountLayer = {
    id: 'cluster-count',
    type: 'symbol',
    source: 'pois',
    paint: {
        'text-color': '#414142'
    },
    filter: ['has', 'point_count'],
    layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12
    }
};

export const unclusteredPointLayer = {
    id: 'pois',
    type: 'symbol',
    source: 'pois',
    filter: ['!', ['has', 'point_count']],
    paint: {
        'text-color': '#414142',
        'text-translate': [0, 2]
    },
    layout: {
        'text-size': 13,
        'text-transform': 'none',
        'text-max-width': 10,
        'text-field': ['get', 'name'],
        'text-anchor': 'top',
        'text-optional': true,
        'icon-size': 1,
        'icon-offset': [0, -20],
        'icon-image': [
            'match',
            ['get', 'poi_type_slug'],
            ['hrib'],
            'hrib',
            ['slap'],
            'slap',
            ['planina'],
            'planina',
            ['jezero'],
            'jezero',
            ['koca'],
            'koca',
            ['bivak'],
            'bivak',
            ['cerkev'],
            'cerkev',
            ['dvorec'],
            'dvorec',
            ['ferata'],
            'ferata',
            ['grad'],
            'grad',
            ['izvir'],
            'izvir',
            ['jama'],
            'jama',
            ['kopalisce'],
            'kopalisce',
            ['muzej-na-prostem'],
            'muzej-na-prostem',
            ['park'],
            'park',
            ['razgledni-stolp'],
            'razgledni-stolp',
            ['soteska'],
            'soteska',
            ['sup-tocka'],
            'sup-tocka',

            'default'
        ]
    }
};
